module.exports = __webpack_public_path__ + "static/media/alarm.6fdd9c20.jpeg";